module.exports = __webpack_public_path__ + "static/media/wheat-hard.706342fc.png";